import React, { PureComponent } from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { Icon, Input } from 'semantic-ui-react';

import moment from 'moment';
import Picker from 'rc-calendar/lib/Picker';
import RangeCalendar from 'rc-calendar/lib/RangeCalendar';

import heIL from 'rc-calendar/lib/locale/he_IL';
import enUS from 'rc-calendar/lib/locale/en_US';

import 'rc-time-picker/assets/index.css';
import 'rc-calendar/assets/index.css';

import './DateRangePicker.scss';

const DATE_FORMAT = "DD/MM/YYYY";

class DateRangePicker extends PureComponent {
    state = {
    };

    constructor(props) {
        super(props);

        this.renderPickerInput = this.renderPickerInput.bind(this);
        this.renderRangeCalendar = this.renderRangeCalendar.bind(this);
    }

    formatDate(date) {
        return date ? date.format(DATE_FORMAT) : '';
    }

    isValidRange(range) {
        return range && range[0] && range[1];
    }

    renderPickerInput({ value }) {
        const { pickerInputStyle } = this.props;

        let pickerValue = '';
        if(this.isValidRange(value)) {
            if(i18next.dir() === 'rtl') {
                pickerValue = `${this.formatDate(value[1])} - ${this.formatDate(value[0])}`;
            } else {
                pickerValue = `${this.formatDate(value[0])} - ${this.formatDate(value[1])}`;
            }
        }

        return (
            <Input
                iconPosition='left'
                icon={<Icon name='calendar alternate outline' />}
                placeholder={i18next.t('datePickers.dateRangePicker.inputPlaceholder')}
                readOnly
                tabIndex="-1"
                className="ant-calendar-picker-input ant-input pi-date-range-picker-input"
                style={pickerInputStyle}
                value={pickerValue}
            />
        );
    }

    renderRangeCalendar() {
        const { defaultCalendarValue, calendarStyle } = this.props;

        return <RangeCalendar
            locale={i18next.language === 'he' ? heIL : enUS}
            dateInputPlaceholder={i18next.t('datePickers.dateRangePicker.calendarPlaceholder')}
            defaultValue={defaultCalendarValue}
            disabledDate={(currentDate) => !this.props.enableFutureDate && moment().isBefore(currentDate)}
            format={DATE_FORMAT}
            placement='left'
            style={{ ...calendarStyle, direction: 'ltr' }}
            className="pi-date-range-calendar"
        />;
    }

    render() {
        const {
            onChange, value,
            calendarStyle, pickerInputStyle, dateRangePickerStyle,
            ...rest
        } = this.props;

        return (
            <Picker
                animation="slide-up"
                value={value}
                onChange={onChange}
                // placement="right"
                calendar={this.renderRangeCalendar()}
                className="pi-date-range-picker"
                style={dateRangePickerStyle}
                {...rest}
            >{this.renderPickerInput}</Picker>
        );

    }
}

DateRangePicker.propTypes = {
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    calendarStyle: PropTypes.object,
    pickerInputStyle: PropTypes.object,
    dateRangePickerStyle: PropTypes.object,
    enableFutureDate: PropTypes.bool,
};

export default DateRangePicker;
